<template>
  <div class="faq-container">
    <div v-if="data" class="FAQ-popup animated zoomIn">
      <div class='popup-title flex'>
        <span>{{ $t('FAQ') }}</span>
        <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="closeFAQ()" />
      </div>
      <div class="FAQ-q">
        <div v-for="item in data" @click="showFAQ(item.link, item.text)">
          {{ item.text }}
        </div>
      </div>
    </div>
    <div class="iframe-div popup-overlay flex animated zoomIn" v-if="showFAQContent">
      <div class='FAQ-popup-title flex'>
        <span>{{ iframeTitle }}</span>
        <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="showFAQ()" />
      </div>
      <iframe :src="iframeSource" style="width: 100% !important; height: 100%;  overflow: scroll !important;">
      </iframe>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Helpdoc',
  props: ["fit20", 'closeFAQ'],
  data() {
    return {
      showFAQContent: false,
      iframeTitle: '',
      iframeSource: '',
      data: false,
    };
  },
  methods: {
    showFAQ: function (link, title) {
      if (link) {
        fetch("https://www.googleapis.com/drive/v3/files/" + link + "/export?mimeType=text/html", {
          headers: {
            "Authorization": "Bearer " + localStorage.getItem('access_token')
          }
        })
          .then(res => res.blob())
          .then(blob => {
            const url = URL.createObjectURL(blob);

            // Insert into an existing iframe
            // const iframe = document.getElementById("my-pdf-frame");
            // iframe.src = url;
            this.iframeSource = url;
            this.iframeTitle = title;
          });

      } else {
        this.iframeSource = "";
        this.iframeTitle = '';
      }
      this.showFAQContent = !this.showFAQContent;
    },
  },
  created: async function () {
    this.fit20.isLoaded = false;
    let helpDoc;
    //const response = await fetch(this.fit20.baseUrl + '/api/translations/help');
    let bucketName =
      this.fit20.baseUrl.includes('test.') || this.fit20.baseUrl.includes('localhost')
        ? 'fit20app-4-acctest.appspot.com'
        : 'fit20app';

    const response = await fetch('https://storage.googleapis.com/' + bucketName + '/static/assets/helpdoc.tsv');
    if (response.ok) {
      helpDoc = await response.text();
      const info = {};
      const lines = helpDoc.split('\n');
      const languages = lines[0].split('\t');
      languages.forEach((lang, index) => {
        lang = lang.replace(/\r/g, "");
        info[lang] = [];
        lines.slice(1).forEach((line, lineIndex) => {
          const columns = line.split('\t');
          columns.forEach((item, i) => {
            if (index == i && (lineIndex % 2 == 0 || info[lang][info[lang].length - 1]['link'])) {
              info[lang].push({ text: item });
            }
            if (index == i && lineIndex % 2 !== 0) {
              info[lang][info[lang].length - 1]['link'] = item ? item : 'null';
            }
          });
        });
      });

      if (this.fit20.user.language) {
        this.data = info[this.fit20.user.language].filter(item => item.text && item.link != 'null');
      } else {
        this.data = info['en-US'].filter(item => item.text && item.link != 'null');;
      }
    } else {
      this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: 'Server error!' });
      this.fit20.errors.push('error with getting help doc!');
      this.fit20.isLoaded = true;
    }

    this.fit20.isLoaded = true;
  }
};
</script>

<style>
.FAQ-popup {
  /* width: 80%; */
  overflow: scroll;
  height: 100%;
}


.FAQ-q {
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  background-color: white;
  padding-bottom: 15px;
}

.FAQ-q div {
  width: 45%;
  border: solid 1px var(--fit20-light-gray);
  border-radius: 10px;
  margin-top: 15px;
  padding: 10px 0 10px 10px;
}

.iframe-div {
  width: 100%;
  height: 95%;
  background-color: white;

}

.iframe-div iframe {
  background-color: white;
  padding: 10px 20px;
}

.FAQ-popup-title {
  width: 100%;
  padding: 10px 20px;
  background-color: var(--fit20-green);
  justify-content: space-between;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: white;
}

.faq-container {
  height: 100%;
}
</style>
